import { useMemo } from "react";
import { IStyleFunctionOrObject } from "@fluentui/merge-styles/lib/IStyleFunction";
import { useTheme } from "@fluentui/react/lib/Theme";
import { IDetailsColumnStyleProps, IDetailsColumnStyles } from "@fluentui/react/lib/DetailsList";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

import { textOverflow } from "Utils/Styles";

const classNames = {
  host: `DataSourceRendererHost`,
  root: `DataSourceRenderer`,
  id: `DataSourceRendererId`
};

export function useDataSourceRendererStyles(
  styles?: IStyleFunctionOrObject<IDetailsColumnStyleProps, IDetailsColumnStyles>
) {
  const { spacing } = useTheme();

  const styleSet = useMemo(
    () => mergeStyleSets(
      {
        host: [classNames.host, {}],
        root: [
          classNames.root,
          {
            width: `100%`
          }
        ],
        id: [
          classNames.id,
          {
            ...textOverflow
          }
        ]
      },
      { host: styles }
    ),
    [styles]
  );

  const iconStyles = useMemo(
    () => mergeStyleSets({
      icon: {
        marginTop: `-3px`,
        marginRight: spacing.s2
      }
    }),
    [spacing]
  );

  return { styleSet, iconStyles };
}
